var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.405273,
    width: 41.1899,
    height: 41.1899,
    rx: 18.3003,
    fill: "#0D4740",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6328 16.8351C11.6328 14.1888 13.7781 12.0435 16.4245 12.0435H24.7578C27.4042 12.0435 29.5495 14.1888 29.5495 16.8351V25.1685C29.5495 27.8148 27.4042 29.9601 24.7578 29.9601H16.4245C13.7781 29.9601 11.6328 27.8148 11.6328 25.1685V16.8351ZM16.6331 25.1678C16.6331 25.513 16.913 25.7928 17.2581 25.7928C17.6033 25.7928 17.8831 25.513 17.8831 25.1678V22.6678C17.8831 22.3226 17.6033 22.0428 17.2581 22.0428C16.913 22.0428 16.6331 22.3226 16.6331 22.6678V25.1678ZM20.5915 25.7928C20.2463 25.7928 19.9665 25.513 19.9665 25.1678V16.8345C19.9665 16.4893 20.2463 16.2095 20.5915 16.2095C20.9366 16.2095 21.2165 16.4893 21.2165 16.8345V25.1678C21.2165 25.513 20.9366 25.7928 20.5915 25.7928ZM23.2998 25.1678C23.2998 25.513 23.5796 25.7928 23.9248 25.7928C24.27 25.7928 24.5498 25.513 24.5498 25.1678V19.3345C24.5498 18.9893 24.27 18.7095 23.9248 18.7095C23.5796 18.7095 23.2998 18.9893 23.2998 19.3345V25.1678Z",
    fill: "#0D4740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.fb1d2b8b300e6e232205f31fa2dfcb73.svg";
export { ForwardRef as ReactComponent };